"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObject = function (value) {
    var type = typeof value;
    return value != null && (type === 'object' || type === 'function');
};
exports.isFunction = function (value) {
    if (!exports.isObject(value))
        return false;
    return typeof value === "function";
};
exports.isArray = function (value) { return exports.isObject(value) && Array.isArray(value); };
exports.identity = function (v) { return v; };
exports.debounce = function (fn, wait) {
    var timeout;
    return function () {
        var ctx = this;
        var args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function () { return fn.apply(ctx, args); }, wait || 0);
    };
};
//# sourceMappingURL=helpers.js.map